module.exports = __webpack_public_path__ + "95b8990e90b114364d491d6a6bc117fc.svg";